import { isAfter, parseISO, subDays } from 'date-fns';

import { useDirectReports } from '@bonusly/user-queries';
import { useCurrentUser } from '@bonusly/who-am-i';

export const useCurrentUserReports = () => {
	const user = useCurrentUser();
	const thirtyDaysAgo = subDays(new Date(), 30);
	const query = useDirectReports(user.id);
	const users = query.data ? query.data.filter((user) => user.deletedAt === null || isAfter(parseISO(user.deletedAt), thirtyDaysAgo)) : [];
	const orderedUsers = users.sort((a, b) => a.displayName.localeCompare(b.displayName));

	return {
		...query,
		data: orderedUsers,
	};
};
